import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const positionService = {
  getAll: async () => {
    return await axios.get(`${domain}/api/Position`, { headers });
  },

  getAllActive: async (departmentId = null) => {
    const url = (departmentId && departmentId !== 0 && departmentId !== "")
      ? `${domain}/api/Position/active?departmentId=${departmentId}`
      : `${domain}/api/Position/active`;

    return await axios.get(url, { headers });
  },

  getById: async (id) => {
    return await axios.get(`${domain}/api/Position/${id}`, { headers });
  },

  create: async (payload) => {
    return await axios.post(`${domain}/api/Position`, payload, { headers });
  },

  update: async (id, payload) => {
    return await axios.put(`${domain}/api/Position/${id}`, payload, { headers });
  },

  delete: async (id) => {
    return await axios.delete(`${domain}/api/Position/${id}`, { headers });
  },
};

export default positionService;